@if (filter()) {
  <sh-form-tag-list-base
    [formControl]="tagValuesControl"
    [placeholder]="$placeholder()"
    [styling]="$tagStyling()"
    [droppanelStyle]="$droppanelStyling()"
    [actionItem]="$actionItem()"
    [autocompleteFct]="$autoCompleteFct()"
    [singleTag]="$singleTag()"
    [editable]="true"
    [limitedButtons]="tagLimitedButtons()"
    >
  </sh-form-tag-list-base>
}
